export default __webpack_public_path__ + "static/media/PFSquareSansProExtraBlackItalic_35483.8df341ae.ttf";